/**
 * Unit Service
 *
 * API calls for unit management
 */

import api from '../utils/api';
import config from '../config';

const unitService = {
  /**
   * Get list of units
   * @param {Object} params - Query parameters (page, pageSize, filters)
   * @returns {Promise} Response data with units list
   */
  getUnits: async (params = {}) => {
    return api.get(config.endpoints.units.list, params);
  },

  /**
   * Get unit initialization data
   * @returns {Promise} Response data with unit levels and other init data
   */
  getUnitInit: async () => {
    return api.get(config.endpoints.units.init);
  },

  /**
   * Get unit by ID
   * @param {number} id - Unit ID
   * @returns {Promise} Response data with unit details
   */
  getUnitById: async (id) => {
    return api.get(`${config.endpoints.units.getById}/${id}`);
  },

  /**
   * Create new unit
   * @param {Object} unitData - Unit data
   * @returns {Promise} Response data with created unit
   */
  createUnit: async (unitData) => {
    return api.post(config.endpoints.units.create, unitData);
  },

  /**
   * Update unit
   * @param {number} id - Unit ID
   * @param {Object} unitData - Updated unit data
   * @returns {Promise} Response data with updated unit
   */
  updateUnit: async (id, unitData) => {
    return api.put(`${config.endpoints.units.update}/${id}`, unitData);
  },

  /**
   * Delete unit
   * @param {number} id - Unit ID
   * @returns {Promise} Response data
   */
  deleteUnit: async (id) => {
    return api.delete(`${config.endpoints.units.delete}/${id}`);
  },

  /**
   * Bulk delete units
   * @param {Array<number>} ids - Array of unit IDs
   * @returns {Promise} Response data
   */
  bulkDeleteUnits: async (ids) => {
    return api.delete(config.endpoints.units.delete, { data: ids });
  },
};

export default unitService;
